module.exports = __webpack_public_path__ + "static/media/g10.23e9beb6.jpg";